import React from 'react';

import QRCode from 'qrcode';

interface QRCodeImageProps {
  url: string;
}
const QRCodeImage: React.FC<QRCodeImageProps> = ({ url }) => {
  const [dataUri, setDataUri] = React.useState('');

  React.useEffect(() => {
    const generateQRCode = () => {
      if (url) {
        QRCode.toDataURL(url, { margin: 0 })
          .then((dataUri: string) => setDataUri(dataUri))
          .catch(err => {
            // eslint-disable-next-line no-console
            console.error('Error generating QR code:', err);
          });
      }
    };
    generateQRCode();
  }, [url]);

  return dataUri ? (
    <img src={dataUri} alt="CFD QR Code" style={{ width: '120px' }} data-test="qrcode-img" />
  ) : null;
};

export { QRCodeImage };
